import type { SanityPageBuilderSection, SanityPageBuilderSpacerSection } from "@ouster/shared";
import { SpacerBlockView } from "~/features/blocks/inventory/spacer";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderSpacerSection;
  };
};
export function SanitySpacerSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  return <SpacerBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasSolidBackground={sectionContent.hasSolidBackground} hasTopDivider={sectionSettings?.hasTopDivider ?? true} isBig={sectionContent.isBig} isHighlighted={sectionContent.isHighlighted} mode={sectionSettings?.mode || "light"} theme={sectionSettings?.theme || "white"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} />;
}